// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 알림톡 - 알림톡 발송 페이지 스타일
 */

.alimtalk-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #E3F2FD 0%, #FFF8E1 100%);
  display: flex;
  flex-direction: column;
}

/* 헤더 */
.alim-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.alim-header-center {
  display: flex;
  align-items: center;
  gap: 10px;
  user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
}

.alim-header h1 {
  font-family: 'Jua', sans-serif;
  font-size: 22px;
  color: #1565C0;
  margin: 0;
  user-select: none;
  -webkit-user-select: none;
}

.alim-header-spacer {
  width: 72px;
}

.alim-header .btn-back {
  background: none;
  border: 2px solid #42A5F5;
  color: #1565C0;
  font-size: 15px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s;
}

.alim-header .btn-back:active {
  background: #42A5F5;
  color: #fff;
}

/* 콘텐츠 - 뷰포트 안에 모두 표시 */
.alim-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  overflow: hidden;
}

/* 검색 섹션 */
.alim-search-section {
  width: 100%;
  max-width: 300px;
  text-align: center;
}

.alim-desc {
  font-family: 'Jua', sans-serif;
  font-size: 15px;
  color: #1565C0;
  line-height: 1.4;
  margin-bottom: 8px;
}

/* 전화번호 표시 영역 */
.alim-phone-display {
  background: #fff;
  border: 3px solid #BBDEFB;
  border-radius: 12px;
  padding: 10px 12px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alim-phone-text {
  font-family: 'Jua', sans-serif;
  font-size: 26px;
  color: #1565C0;
  letter-spacing: 2px;
  user-select: none;
  -webkit-user-select: none;
  pointer-events: none;
}

.alim-phone-text.placeholder {
  color: #BBDEFB;
}

/* 숫자패드 */
.alim-numpad {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.alim-numpad-row {
  display: flex;
  gap: 6px;
  justify-content: center;
}

.alim-numpad-key {
  width: 76px;
  height: 42px;
  border: none;
  border-radius: 10px;
  background: #fff;
  color: #333;
  font-family: 'Jua', sans-serif;
  font-size: 22px;
  cursor: pointer;
  transition: background 0.1s, transform 0.1s;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.alim-numpad-key:active {
  background: #E3F2FD;
  transform: scale(0.95);
}

.alim-numpad-key.key-clear {
  background: #FFEBEE;
  color: #C62828;
  font-size: 17px;
}

.alim-numpad-key.key-clear:active {
  background: #FFCDD2;
}

.alim-numpad-key.key-backspace {
  background: #FFF3E0;
  color: #E65100;
  font-size: 20px;
}

.alim-numpad-key.key-backspace:active {
  background: #FFE0B2;
}

/* 조회 버튼 */
.btn-search {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #42A5F5, #1E88E5);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
  margin-top: 2px;
}

.btn-search:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.btn-search:not(:disabled):active {
  transform: scale(0.97);
}

/* 에러 */
.alim-error {
  margin-top: 16px;
  padding: 12px 16px;
  background: #FFEBEE;
  color: #C62828;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
}

/* 로딩 */
.alim-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 80px;
}

.alim-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #BBDEFB;
  border-top-color: #42A5F5;
  border-radius: 50%;
  animation: alim-spin 0.8s linear infinite;
}

@keyframes alim-spin {
  to { transform: rotate(360deg); }
}

.alim-loading p {
  font-size: 16px;
  color: #546E7A;
}

/* 회원 카드 */
.alim-member-card {
  background: #fff;
  border-radius: 20px;
  padding: 28px 24px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  max-width: 440px;
  width: 100%;
  animation: alim-fadeIn 0.3s ease;
}

@keyframes alim-fadeIn {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

.alim-member-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #E3F2FD;
}

.alim-member-avatar {
  font-size: 48px;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #E3F2FD;
  border-radius: 50%;
}

.alim-member-name {
  font-family: 'Jua', sans-serif;
  font-size: 22px;
  color: #333;
  margin: 0 0 4px;
}

.alim-member-id {
  font-size: 12px;
  color: #999;
  font-family: monospace;
}

/* 정보 그리드 */
.alim-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 24px;
}

.alim-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.alim-info-label {
  font-size: 12px;
  color: #999;
  font-weight: 500;
}

.alim-info-value {
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

/* 결과 메시지 */
.alim-result {
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 16px;
  animation: alim-fadeIn 0.3s ease;
}

.alim-result.success {
  background: #E8F5E9;
  color: #2E7D32;
}

.alim-result.fail {
  background: #FFEBEE;
  color: #C62828;
}

/* 액션 버튼 */
.alim-action-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-send {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #42A5F5, #1E88E5);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
}

.btn-send:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-send:not(:disabled):active {
  transform: scale(0.97);
}

.btn-reset {
  width: 100%;
  padding: 14px;
  background: #E0E0E0;
  color: #555;
  border: none;
  border-radius: 14px;
  font-size: 17px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
}

.btn-reset:active {
  transform: scale(0.97);
}

/* 미등록 회원 가입 확인 팝업 */
.alim-confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  animation: alim-fadeIn 0.2s ease;
}

.alim-confirm-popup {
  background: #fff;
  border-radius: 20px;
  padding: 28px 24px;
  max-width: 340px;
  width: 90%;
  text-align: center;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.2);
  animation: alim-fadeIn 0.3s ease;
}

.alim-confirm-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

.alim-confirm-popup h3 {
  font-family: 'Jua', sans-serif;
  font-size: 20px;
  color: #333;
  margin: 0 0 8px;
}

.alim-confirm-popup p {
  font-size: 15px;
  color: #666;
  margin: 0 0 8px;
  line-height: 1.4;
}

.alim-confirm-phone {
  font-family: 'Jua', sans-serif;
  font-size: 24px;
  color: #1565C0;
  background: #E3F2FD;
  border-radius: 12px;
  padding: 10px 16px;
  margin: 12px 0;
  letter-spacing: 1px;
}

.alim-confirm-note {
  font-size: 13px;
  color: #999;
}

.alim-confirm-buttons {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}

.btn-confirm-cancel {
  flex: 1 1;
  padding: 14px;
  background: #E0E0E0;
  color: #555;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
}

.btn-confirm-cancel:active {
  transform: scale(0.97);
}

.btn-confirm-ok {
  flex: 1 1;
  padding: 14px;
  background: linear-gradient(135deg, #42A5F5, #1E88E5);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
}

.btn-confirm-ok:active {
  transform: scale(0.97);
}
`, "",{"version":3,"sources":["webpack://./src/pages/AlimtalkPage.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;AACxB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,OAAO;AACP;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/**\n * 알림톡 - 알림톡 발송 페이지 스타일\n */\n\n.alimtalk-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #E3F2FD 0%, #FFF8E1 100%);\n  display: flex;\n  flex-direction: column;\n}\n\n/* 헤더 */\n.alim-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.alim-header-center {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  user-select: none;\n  -webkit-user-select: none;\n  cursor: pointer;\n}\n\n.alim-header h1 {\n  font-family: 'Jua', sans-serif;\n  font-size: 22px;\n  color: #1565C0;\n  margin: 0;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.alim-header-spacer {\n  width: 72px;\n}\n\n.alim-header .btn-back {\n  background: none;\n  border: 2px solid #42A5F5;\n  color: #1565C0;\n  font-size: 15px;\n  font-weight: 600;\n  padding: 8px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.alim-header .btn-back:active {\n  background: #42A5F5;\n  color: #fff;\n}\n\n/* 콘텐츠 - 뷰포트 안에 모두 표시 */\n.alim-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 20px;\n  overflow: hidden;\n}\n\n/* 검색 섹션 */\n.alim-search-section {\n  width: 100%;\n  max-width: 300px;\n  text-align: center;\n}\n\n.alim-desc {\n  font-family: 'Jua', sans-serif;\n  font-size: 15px;\n  color: #1565C0;\n  line-height: 1.4;\n  margin-bottom: 8px;\n}\n\n/* 전화번호 표시 영역 */\n.alim-phone-display {\n  background: #fff;\n  border: 3px solid #BBDEFB;\n  border-radius: 12px;\n  padding: 10px 12px;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.alim-phone-text {\n  font-family: 'Jua', sans-serif;\n  font-size: 26px;\n  color: #1565C0;\n  letter-spacing: 2px;\n  user-select: none;\n  -webkit-user-select: none;\n  pointer-events: none;\n}\n\n.alim-phone-text.placeholder {\n  color: #BBDEFB;\n}\n\n/* 숫자패드 */\n.alim-numpad {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.alim-numpad-row {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n}\n\n.alim-numpad-key {\n  width: 76px;\n  height: 42px;\n  border: none;\n  border-radius: 10px;\n  background: #fff;\n  color: #333;\n  font-family: 'Jua', sans-serif;\n  font-size: 22px;\n  cursor: pointer;\n  transition: background 0.1s, transform 0.1s;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.alim-numpad-key:active {\n  background: #E3F2FD;\n  transform: scale(0.95);\n}\n\n.alim-numpad-key.key-clear {\n  background: #FFEBEE;\n  color: #C62828;\n  font-size: 17px;\n}\n\n.alim-numpad-key.key-clear:active {\n  background: #FFCDD2;\n}\n\n.alim-numpad-key.key-backspace {\n  background: #FFF3E0;\n  color: #E65100;\n  font-size: 20px;\n}\n\n.alim-numpad-key.key-backspace:active {\n  background: #FFE0B2;\n}\n\n/* 조회 버튼 */\n.btn-search {\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(135deg, #42A5F5, #1E88E5);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n  margin-top: 2px;\n}\n\n.btn-search:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.btn-search:not(:disabled):active {\n  transform: scale(0.97);\n}\n\n/* 에러 */\n.alim-error {\n  margin-top: 16px;\n  padding: 12px 16px;\n  background: #FFEBEE;\n  color: #C62828;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n/* 로딩 */\n.alim-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  margin-top: 80px;\n}\n\n.alim-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #BBDEFB;\n  border-top-color: #42A5F5;\n  border-radius: 50%;\n  animation: alim-spin 0.8s linear infinite;\n}\n\n@keyframes alim-spin {\n  to { transform: rotate(360deg); }\n}\n\n.alim-loading p {\n  font-size: 16px;\n  color: #546E7A;\n}\n\n/* 회원 카드 */\n.alim-member-card {\n  background: #fff;\n  border-radius: 20px;\n  padding: 28px 24px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);\n  max-width: 440px;\n  width: 100%;\n  animation: alim-fadeIn 0.3s ease;\n}\n\n@keyframes alim-fadeIn {\n  from { opacity: 0; transform: translateY(12px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.alim-member-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #E3F2FD;\n}\n\n.alim-member-avatar {\n  font-size: 48px;\n  width: 64px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #E3F2FD;\n  border-radius: 50%;\n}\n\n.alim-member-name {\n  font-family: 'Jua', sans-serif;\n  font-size: 22px;\n  color: #333;\n  margin: 0 0 4px;\n}\n\n.alim-member-id {\n  font-size: 12px;\n  color: #999;\n  font-family: monospace;\n}\n\n/* 정보 그리드 */\n.alim-info-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.alim-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.alim-info-label {\n  font-size: 12px;\n  color: #999;\n  font-weight: 500;\n}\n\n.alim-info-value {\n  font-size: 16px;\n  color: #333;\n  font-weight: 600;\n}\n\n/* 결과 메시지 */\n.alim-result {\n  padding: 12px 16px;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 16px;\n  animation: alim-fadeIn 0.3s ease;\n}\n\n.alim-result.success {\n  background: #E8F5E9;\n  color: #2E7D32;\n}\n\n.alim-result.fail {\n  background: #FFEBEE;\n  color: #C62828;\n}\n\n/* 액션 버튼 */\n.alim-action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.btn-send {\n  width: 100%;\n  padding: 16px;\n  background: linear-gradient(135deg, #42A5F5, #1E88E5);\n  color: #fff;\n  border: none;\n  border-radius: 14px;\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.btn-send:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-send:not(:disabled):active {\n  transform: scale(0.97);\n}\n\n.btn-reset {\n  width: 100%;\n  padding: 14px;\n  background: #E0E0E0;\n  color: #555;\n  border: none;\n  border-radius: 14px;\n  font-size: 17px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.btn-reset:active {\n  transform: scale(0.97);\n}\n\n/* 미등록 회원 가입 확인 팝업 */\n.alim-confirm-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  animation: alim-fadeIn 0.2s ease;\n}\n\n.alim-confirm-popup {\n  background: #fff;\n  border-radius: 20px;\n  padding: 28px 24px;\n  max-width: 340px;\n  width: 90%;\n  text-align: center;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.2);\n  animation: alim-fadeIn 0.3s ease;\n}\n\n.alim-confirm-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n}\n\n.alim-confirm-popup h3 {\n  font-family: 'Jua', sans-serif;\n  font-size: 20px;\n  color: #333;\n  margin: 0 0 8px;\n}\n\n.alim-confirm-popup p {\n  font-size: 15px;\n  color: #666;\n  margin: 0 0 8px;\n  line-height: 1.4;\n}\n\n.alim-confirm-phone {\n  font-family: 'Jua', sans-serif;\n  font-size: 24px;\n  color: #1565C0;\n  background: #E3F2FD;\n  border-radius: 12px;\n  padding: 10px 16px;\n  margin: 12px 0;\n  letter-spacing: 1px;\n}\n\n.alim-confirm-note {\n  font-size: 13px;\n  color: #999;\n}\n\n.alim-confirm-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.btn-confirm-cancel {\n  flex: 1;\n  padding: 14px;\n  background: #E0E0E0;\n  color: #555;\n  border: none;\n  border-radius: 14px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n}\n\n.btn-confirm-cancel:active {\n  transform: scale(0.97);\n}\n\n.btn-confirm-ok {\n  flex: 1;\n  padding: 14px;\n  background: linear-gradient(135deg, #42A5F5, #1E88E5);\n  color: #fff;\n  border: none;\n  border-radius: 14px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n}\n\n.btn-confirm-ok:active {\n  transform: scale(0.97);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
